// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__R35uw"};